import type { ClassValue } from "clsx";

import { cn } from "@lib/utils";

export const ctaButtonBaseClassName =
  "bg-[linear-gradient(120deg,#BAFCEB_0%,#69F59C_36%,#D6FD4B_94%)] text-gray-700 font-medium shadow-[0_0_4px_rgba(105,245,156,0.35)] hover:shadow-[0_0_8px_rgba(105,245,156,0.65),0_0_8px_rgba(214,253,75,0.35)] transition-shadow duration-300";

export function ctaButtonClassName(...classNames: ClassValue[]) {
  return cn(ctaButtonBaseClassName, ...classNames);
}

export const darkGradient =
  "linear-gradient(25deg, #05DF54 0%, #1CF36B 36%, #96C5F0 94%)";

export const lightGradient =
  "linear-gradient(120deg, #BAFCEB 0%, #69F59C 36%, #D6FD4B 94%)";

export const lightGradientOpaque =
  "linear-gradient(120deg, #BAFCEB10 0%, #69F59210 36%, #D6FD4B10 94%)";